(() => {
  'use strict';

  const DEBUG = true;
  function log(...args) {
    if (DEBUG) console.log('[mobile-bottom-nav]', ...args);
  }

  const THEME = window.THEME_GLOBAL || { BREAKPOINT: { TABLET: 767 } };
  const TABLET_MAX = THEME.BREAKPOINT?.TABLET ?? 767;
  const IS_PRODUCT_PAGE = document.body.classList.contains('template-product');

  const bottomNav = document.querySelector('[data-mobile-bottom-nav]');
  const bottomNavShell = document.querySelector('[data-mobile-bottom-nav-shell]');
  if (!bottomNav) return;

  const navListWrap = bottomNav.querySelector('.mobile-bottom-nav__list-wrap');
  const navList = bottomNav.querySelector('.mobile-bottom-nav__list');
  const INDICATOR_TRANSITION_MS = 380;
  const NAV_PENDING_KEY = 'mobile-nav-pending-action';
  const SHEET_CLOSE_MS = 320;
  let accountSheetOpen = false;
  let wasAccountDrawerOpen = false;
  let searchPanelOpen = false;
  let wasBoostSearchOpen = false;
  let categorySheetHome = null;
  let navTransitionLock = null;
  let accountCloseTimer = null;
  let categoryCloseInProgress = false;
  let accountSyncBusy = false;
  let accountDrawerWasOpen = false;
  let wasCategorySheetOpen = document.body.classList.contains('mobile-menu-sheet-open');
  let lastIndicatorAction = null;
  let indicatorAnimating = false;
  let indicatorAnimTimer = null;

  function getCategorySheet() {
    return document.querySelector('.mobile_menu--bottom-nav');
  }

  function dockCategorySheetToBody() {
    if (!isMobileBottomNavViewport()) return;
    const sheet = getCategorySheet();
    if (!sheet) return;
    if (!categorySheetHome) categorySheetHome = sheet.parentElement;

    const backdrop = ensureSheetBackdrop();
    const alreadyDocked =
      sheet.parentElement === document.body && sheet.previousElementSibling === backdrop;
    if (!alreadyDocked) {
      backdrop.insertAdjacentElement('afterend', sheet);
    }
    dockBottomNavToBody();
    const dockTarget = bottomNavShell || bottomNav;
    if (sheet.parentElement === document.body && dockTarget.parentElement === document.body) {
      sheet.insertAdjacentElement('afterend', dockTarget);
    }
  }

  function restoreCategorySheet() {
    const sheet = getCategorySheet();
    if (!sheet || !categorySheetHome || sheet.parentElement === categorySheetHome) return;
    categorySheetHome.appendChild(sheet);
  }

  function ensureSheetBackdrop() {
    let backdrop = document.getElementById('mobile-sheet-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.id = 'mobile-sheet-backdrop';
      backdrop.className = 'mobile-sheet-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.addEventListener('click', () => {
        if (document.body.classList.contains('mobile-menu-sheet-open')) {
          closeCategoryMenuAnimated(() => setActiveItem());
        }
      });
      document.body.appendChild(backdrop);
    }
    return backdrop;
  }

  function syncSheetBackdrop() {
    if (!isMobileBottomNavViewport()) {
      document.getElementById('mobile-sheet-backdrop')?.classList.remove('is-visible');
      return;
    }
    const categoryOpen = document.body.classList.contains('mobile-menu-sheet-open');
    const categoryDismissing = document.body.classList.contains('mobile-menu-sheet-dismissing');
    const backdrop = ensureSheetBackdrop();
    const wasVisible = backdrop.classList.contains('is-visible');
    backdrop.classList.toggle('is-visible', categoryOpen || categoryDismissing);
    backdrop.setAttribute('aria-hidden', categoryOpen || categoryDismissing ? 'false' : 'true');
    syncHeaderAnnouncementForOverlays();
    if (categoryOpen || categoryDismissing) {
      if (!wasVisible && categoryOpen) dockCategorySheetToBody();
      else dockBottomNavToBody();
    } else {
      restoreCategorySheet();
    }
  }

  function isCategorySheetActive() {
    return (
      document.body.classList.contains('mobile-menu-sheet-open') &&
      !document.body.classList.contains('mobile-menu-sheet-dismissing')
    );
  }

  function isAccountSheetActive() {
    return (
      document.body.classList.contains('mobile-account-sheet-open') || accountSheetOpen
    );
  }

  function isOverlayHidingAnnouncement() {
    return isCategorySheetActive() || isAccountSheetActive();
  }

  function getPageScrollTop() {
    return (
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  function isElementPaintedInViewport(el) {
    if (!el) return false;
    if (el.getAttribute('aria-hidden') === 'true' || el.hasAttribute('hidden')) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const rect = el.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;
    const vw = window.innerWidth || document.documentElement.clientWidth;
    const vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.left < vw && rect.right > 0 && rect.top < vh && rect.bottom > 0;
  }

  function syncHeaderAnnouncementForOverlays() {
    const root = document.documentElement;
    const isIndex = document.body.classList.contains('template-index');
    const overlayActive = isOverlayHidingAnnouncement();

    if (overlayActive) {
      root.style.setProperty('--announcement-bar-height', '0px');
      if (isIndex) {
        root.setAttribute('data-scroll-at-the-top', 'false');
      }
      return;
    }

    if (isIndex) {
      root.setAttribute('data-scroll-at-the-top', getPageScrollTop() <= 2 ? 'true' : 'false');
    }

    root.style.removeProperty('--announcement-bar-height');
    document.querySelector('announcement-bar')?.syncAnnouncementBarHeight?.();
  }

  function isMobileBottomNavViewport() {
    return window.innerWidth <= TABLET_MAX && !IS_PRODUCT_PAGE;
  }

  function getMobileNavToggler() {
    return document.querySelector(
      '.section-header__content.menu_toggle [data-purpose="nav-toggler"]',
    );
  }

  function getMobileSearchInput() {
    return (
      bottomNav.querySelector('.mobile-bottom-nav__search-source .boost-pfs-search-input') ||
      document.querySelector('form.boost-pfs-search-form .boost-pfs-search-input')
    );
  }

  function hasOpenNavOverlay() {
    return (
      document.body.classList.contains('mobile-menu-sheet-open') ||
      isSearchOpen() ||
      searchPanelOpen ||
      accountSheetOpen
    );
  }

  function syncBodyClass() {
    document.body.classList.toggle('has-mobile-bottom-nav', isMobileBottomNavViewport());
    dockBottomNavToBody();
  }

  function dockBottomNavToBody() {
    if (!isMobileBottomNavViewport()) return;
    const dockTarget = bottomNavShell || bottomNav;
    if (dockTarget.parentElement !== document.body) {
      document.body.appendChild(dockTarget);
    }
  }

  function resetStaleMobileMenuState() {
    if (!isMobileBottomNavViewport()) return;

    const toggler = getMobileNavToggler();
    const sheetOpen = document.body.classList.contains('mobile-menu-sheet-open');
    const menuActive = Boolean(toggler?.classList.contains('menu-is-active'));

    if (sheetOpen && menuActive) return;

    document.body.classList.remove('mobile-menu-sheet-open', 'menu-is-active');
    document.querySelector('.header')?.classList.remove('menu-is-active');
    if (toggler) {
      toggler.classList.remove('menu-is-active');
      toggler.setAttribute('aria-expanded', 'false');
    }
  }

  function markPendingNavAction(action) {
    if (!action) return;
    try {
      sessionStorage.setItem(NAV_PENDING_KEY, action);
    } catch (err) {
      /* ignore storage failures */
    }
  }

  function consumePendingNavAction() {
    try {
      const pending = sessionStorage.getItem(NAV_PENDING_KEY);
      sessionStorage.removeItem(NAV_PENDING_KEY);
      return pending;
    } catch (err) {
      return null;
    }
  }

  function getActiveNavAction() {
    if (navTransitionLock) return navTransitionLock;

    const pageType = bottomNav.dataset.pageType;
    const isCategoryOpen = document.body.classList.contains('mobile-menu-sheet-open');

    if (isCategoryOpen) return 'category';
    if (accountSheetOpen || isAccountDrawerOpen()) return 'account';
    if (isSearchOpen() || searchPanelOpen || pageType === 'search') return 'search';

    if (
      pageType === 'collection' ||
      pageType === 'list-collections' ||
      pageType === 'blog' ||
      pageType === 'article' ||
      pageType === 'page'
    ) {
      return 'category';
    }

    if (pageType === 'index') return 'home';
    if (pageType === 'cart') return 'cart';
    if (
      pageType === 'customers/account' ||
      pageType === 'customers/login' ||
      pageType === 'customers/register' ||
      pageType === 'customers/order' ||
      pageType === 'customers/addresses'
    ) {
      return 'account';
    }

    return null;
  }

  function updateNavIndicator(activeAction, { animate = true, force = false } = {}) {
    const indicator = bottomNav.querySelector('[data-mobile-nav-indicator]');
    if (!indicator || !navListWrap || !navList) return;

    if (!activeAction) {
      lastIndicatorAction = null;
      indicator.hidden = true;
      return;
    }

    const activeEl = bottomNav.querySelector(`[data-mobile-nav-action="${activeAction}"]`);
    const item = activeEl?.closest('.mobile-bottom-nav__item');
    if (!item) {
      lastIndicatorAction = null;
      indicator.hidden = true;
      return;
    }

    const items = [...navList.querySelectorAll('.mobile-bottom-nav__item')];
    const index = items.indexOf(item);
    if (index < 0) return;

    if (!force && animate && activeAction === lastIndicatorAction && !indicator.hidden) {
      return;
    }

    lastIndicatorAction = activeAction;
    indicator.style.setProperty('--nav-count', String(items.length));
    indicator.style.setProperty('--indicator-left', '0px');
    indicator.style.setProperty('--indicator-x', `${item.offsetLeft}px`);
    indicator.style.setProperty('--indicator-width', `${item.offsetWidth}px`);

    if (!animate) {
      indicator.classList.add('mobile-bottom-nav__indicator--instant');
    } else {
      indicatorAnimating = true;
      window.clearTimeout(indicatorAnimTimer);
      indicatorAnimTimer = window.setTimeout(() => {
        indicatorAnimating = false;
      }, INDICATOR_TRANSITION_MS);
    }

    indicator.hidden = false;
    indicator.style.setProperty('--active-index', String(index));

    if (!animate) {
      indicator.getBoundingClientRect();
      indicator.classList.remove('mobile-bottom-nav__indicator--instant');
    }
  }

  function applySearchBottomOffset() {
    if (!isMobileBottomNavViewport()) return;

    document.body.classList.add('has-mobile-bottom-nav');
    dockBottomNavToBody();

    const offset =
      getComputedStyle(document.body).getPropertyValue('--mobile-bottom-nav-offset').trim() || '4.5rem';
    const top =
      getComputedStyle(document.documentElement)
        .getPropertyValue('--instant-search-wrapper-offset-top-mobile')
        .trim() || '4rem';

    const selectors = [
      '.boost-pfs-search-suggestion-mobile.boost-pfs-search-suggestion-wrapper',
      '.boost-pfs-search-suggestion-wrapper[data-is-results-wrapper="true"]',
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (!el.classList.contains('boost-pfs-search-suggestion-mobile') && selector.includes('data-is-results-wrapper')) {
          return;
        }
        el.style.setProperty('top', top, 'important');
        el.style.setProperty('bottom', offset, 'important');
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('max-height', 'none', 'important');
        el.style.setProperty('padding-bottom', '0', 'important');
      });
    });

    document.querySelectorAll('.boost-pfs-search-suggestion-mobile-overlay').forEach((el) => {
      el.style.setProperty('bottom', offset, 'important');
      el.style.setProperty('height', 'auto', 'important');
    });

    document
      .querySelectorAll(
        '.boost-pfs-search-suggestion-mobile .boost-pfs-search-suggestion, .boost-pfs-search-suggestion-mobile .boost-pfs-search-suggestion-scroll-groups-element-wrapper',
      )
      .forEach((el) => {
        if (el.classList.contains('boost-pfs-search-suggestion-scroll-groups-element-wrapper')) {
          el.style.setProperty('max-height', 'none', 'important');
          el.style.setProperty('overflow-y', 'visible', 'important');
          return;
        }
        el.style.setProperty('height', '100%', 'important');
        el.style.setProperty('max-height', '100%', 'important');
        el.style.setProperty('overflow-y', 'auto', 'important');
      });
  }

  function isShopifyAccountDialogOpen() {
    const accountEl = document.querySelector('shopify-account');
    if (!accountEl) return false;

    const dialog = accountEl.shadowRoot?.querySelector('dialog[open]');
    if (dialog) return true;

    return isElementPaintedInViewport(accountEl);
  }

  function isAccountDrawerOpen() {
    const drawerSelectors = [
      '[class*="Drawer-fullscreenVertical"]',
      '[class*="Drawer-drawerParent"]',
      '[class*="Modal-opened"]',
    ];

    for (const selector of drawerSelectors) {
      const el = document.querySelector(selector);
      if (isElementPaintedInViewport(el)) return true;
    }

    return isShopifyAccountDialogOpen();
  }

  function setActiveItem() {
    const activeAction = getActiveNavAction();
    log('setActiveItem', { activeAction, navTransitionLock, accountSheetOpen, searchPanelOpen });
    setNavActionActive(activeAction);
  }

  function releaseOverlayNavLock(action) {
    if (navTransitionLock !== action) return;
    navTransitionLock = null;
    syncHeaderAnnouncementForOverlays();
    setActiveItem();
  }

  function pressNavAction(action) {
    log('pressNavAction', action);
    navTransitionLock = action;
    setNavActionActive(action);
  }

  log('init');
  syncBodyClass();
  document.body.classList.remove('mobile-nav-search-dismissed');
  injectAccountDrawerStyleTag();
  resetStaleMobileMenuState();
  document.querySelectorAll('[data-mobile-nav-aria-hidden="true"]').forEach((el) => {
    const prev = el.getAttribute('data-mobile-nav-aria-previous');
    if (prev === '') el.removeAttribute('aria-hidden');
    else if (prev != null) el.setAttribute('aria-hidden', prev);
    el.removeAttribute('data-mobile-nav-aria-hidden');
    el.removeAttribute('data-mobile-nav-aria-previous');
  });
  syncSheetBackdrop();
  consumePendingNavAction();
  syncHeaderAnnouncementForOverlays();
  setNavActionActive(getActiveNavAction(), { animateIndicator: false });

  window.addEventListener('pageshow', () => {
    syncHeaderAnnouncementForOverlays();
    setActiveItem();
  });

  if (typeof ResizeObserver !== 'undefined' && navListWrap) {
    new ResizeObserver(() => {
      if (!isMobileBottomNavViewport() || indicatorAnimating) return;
      const activeAction = navTransitionLock || getActiveNavAction();
      if (activeAction) {
        updateNavIndicator(activeAction, { animate: false, force: true });
      }
    }).observe(navListWrap);
  }

  window.addEventListener('resize', () => {
    syncBodyClass();
    resetStaleMobileMenuState();
    syncSheetBackdrop();
    const activeAction = getActiveNavAction();
    setNavActionActive(activeAction, { animateIndicator: false });
    applySearchBottomOffset();
  });

  function initBoostSearchHandlers({ wrapper, resultsWrapper, overlay, topPanel, closeButton }) {
    if (!wrapper || !resultsWrapper || !overlay || !topPanel || !closeButton) return;
    if (wrapper.dataset.isHandled === 'true') return;

    wrapper.dataset.isHandled = 'true';
    overlay.addEventListener('click', () => closeButton.click());
    resultsWrapper.dataset.isResultsWrapper = 'true';

    new MutationObserver(() => {
      const searchBox = topPanel.querySelector('.boost-pfs-search-box');
      if (searchBox) searchBox.focus();
    }).observe(wrapper, { attributes: true });
  }

  function closeMobileSearch() {
    searchPanelOpen = false;
    const sdClose = document.querySelector(
      '.boost-sd__search-bar-wrapper .boost-sd__button-text-x--close-style1, .boost-sd__search-bar-wrapper .boost-sd__button-text-x--close-style3',
    );
    if (sdClose) sdClose.click();

    const closeBtn = document.querySelector(
      '.boost-pfs-search-suggestion-mobile-top-panel .boost-pfs-search-btn-close-suggestion',
    );
    if (closeBtn) {
      closeBtn.click();
    } else {
      const overlay = document.querySelector('.boost-pfs-search-suggestion-mobile-overlay');
      if (overlay) overlay.click();
    }
    document.body.classList.add('mobile-nav-search-dismissed');
    window.setTimeout(() => releaseOverlayNavLock('search'), 0);
  }

  function hasBoostSearchOpenClass() {
    const roots = [document.body, document.documentElement];
    return roots.some(
      (root) =>
        root.classList.contains('boost-pfs-search-suggestion-mobile-open') ||
        root.classList.contains('boost-pfs-search-suggestion-open-body'),
    );
  }

  function isBoostSearchModalVisible() {
    const selectors = [
      '.boost-pfs-search-suggestion-mobile-overlay',
      '.boost-pfs-search-suggestion-mobile-top-panel',
      '.boost-pfs-search-suggestion-mobile.boost-pfs-search-suggestion-wrapper',
    ];
  
    return selectors.some((selector) => {
      const el = document.querySelector(selector);
      if (!el) return false;
  
      if (el.getAttribute('aria-hidden') === 'true' || el.hasAttribute('hidden')) {
        return false;
      }
  
      const style = window.getComputedStyle(el);
  
      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        parseFloat(style.opacity || '1') === 0
      ) {
        return false;
      }
  
      const rect = el.getBoundingClientRect();
  
      return rect.width > 0 && rect.height > 0;
    });
  }

  function isSearchOpen() {
    if (document.body.classList.contains('mobile-nav-search-dismissed')) return false;
    return hasBoostSearchOpenClass() || isBoostSearchModalVisible();
  }

  function syncSearchPanelState() {
    const boostOpen =
      !document.body.classList.contains('mobile-nav-search-dismissed') &&
      (hasBoostSearchOpenClass() || isBoostSearchModalVisible());
  
    const searchJustClosed = wasBoostSearchOpen && !boostOpen;
  
    if (boostOpen) {
      searchPanelOpen = true;
    }
  
    if (searchJustClosed) {
      searchPanelOpen = false;
      releaseOverlayNavLock('search');
    }
  
    wasBoostSearchOpen = boostOpen;
  }

  function syncCategorySheetState() {
    const categoryOpen = document.body.classList.contains('mobile-menu-sheet-open');
    const categoryJustClosed = wasCategorySheetOpen && !categoryOpen;

    wasCategorySheetOpen = categoryOpen;
    if (categoryJustClosed) {
      syncHeaderAnnouncementForOverlays();
      releaseOverlayNavLock('category');
    }
  }

  function openMobileSearch() {
    document.body.classList.remove('mobile-nav-search-dismissed');
  
    // If Boost search is already actually open, don't trigger it again.
    if (hasBoostSearchOpenClass() || isBoostSearchModalVisible()) {
      searchPanelOpen = true;
      setActiveItem();
      applySearchBottomOffset();
  
      const input = getMobileSearchInput();
  
      if (input) {
        requestAnimationFrame(() => {
          try {
            input.focus({ preventScroll: true });
          } catch (e) {
            input.focus();
          }
        });
      }
  
      return;
    }
  
    if (document.body.classList.contains('mobile-menu-sheet-open')) {
      closeCategoryMenu();
    }
  
    const input = getMobileSearchInput();
  
    if (!input) {
      log('openMobileSearch: search input not found');
      return;
    }
  
    searchPanelOpen = true;
    pressNavAction('search');
  
    // IMPORTANT:
    // Trigger Boost while still inside the user's click event.
    input.click();
  
    const wrappers = [
      ...document.querySelectorAll(
        '.boost-pfs-search-suggestion-wrapper'
      ),
    ];
  
    const [w1, w2] = wrappers;
  
    initBoostSearchHandlers({
      wrapper: w1,
      resultsWrapper: w2,
      overlay: document.querySelector(
        '.boost-pfs-search-suggestion-mobile-overlay'
      ),
      topPanel: document.querySelector(
        '.boost-pfs-search-suggestion-mobile-top-panel'
      ),
      closeButton: document.querySelector(
        '.boost-pfs-search-suggestion-mobile-top-panel .boost-pfs-search-btn-close-suggestion'
      ),
    });
  
    // Let Boost render first.
    requestAnimationFrame(() => {
      applySearchBottomOffset();
  
      requestAnimationFrame(() => {
        const currentInput = getMobileSearchInput();
  
        if (!currentInput) return;
  
        try {
          currentInput.focus({ preventScroll: true });
        } catch (e) {
          currentInput.focus();
        }
      });
    });
  }

  function syncAccountSheetState() {
    if (accountSyncBusy) return;
    accountSyncBusy = true;

    try {
      const open = isAccountDrawerOpen();
      log('syncAccountSheetState', { open, accountSheetOpen, wasAccountDrawerOpen, navTransitionLock });

      if (open) {
        window.clearTimeout(accountCloseTimer);
        accountCloseTimer = null;
        accountSheetOpen = true;
        accountDrawerWasOpen = true;
        wasAccountDrawerOpen = true;
        document.body.classList.add('mobile-account-sheet-open');
        syncHeaderAnnouncementForOverlays();
        setActiveItem();
        return;
      }

      if (wasAccountDrawerOpen || accountDrawerWasOpen || accountSheetOpen) {
        if (!accountCloseTimer) {
          accountCloseTimer = window.setTimeout(() => {
            accountCloseTimer = null;
            if (isAccountDrawerOpen()) {
              accountSheetOpen = true;
              wasAccountDrawerOpen = true;
              document.body.classList.add('mobile-account-sheet-open');
              syncHeaderAnnouncementForOverlays();
              return;
            }
            log('syncAccountSheetState: drawer closed');
            accountSheetOpen = false;
            accountDrawerWasOpen = false;
            wasAccountDrawerOpen = false;
            document.body.classList.remove('mobile-account-sheet-open');
            syncHeaderAnnouncementForOverlays();
            if (navTransitionLock === 'account') navTransitionLock = null;
            setActiveItem();
          }, 250);
        }
        return;
      }

      if (accountSheetOpen) {
        setActiveItem();
      }
    } finally {
      accountSyncBusy = false;
    }
  }

  function injectAccountDrawerStyleTag() {
    if (document.getElementById('mobile-account-drawer-fix')) return;
    const style = document.createElement('style');
    style.id = 'mobile-account-drawer-fix';
    style.textContent = `
      @media (max-width: 767px) {
        body.has-mobile-bottom-nav [class*="Drawer-drawerParent"] {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: var(--mobile-bottom-nav-offset, 4.5rem) !important;
          height: auto !important;
          max-height: none !important;
          z-index: 10000000009 !important;
          align-items: flex-end !important;
          justify-content: center !important;
        }
        body.has-mobile-bottom-nav [class*="Drawer-fullscreenVertical"] {
          height: 70vh !important;
          max-height: 70vh !important;
          top: auto !important;
          bottom: var(--mobile-bottom-nav-offset, 4.5rem) !important;
          border-radius: 1.5rem 1.5rem 0 0 !important;
          transform: none !important;
          z-index: 10000000009 !important;
        }
        body.has-mobile-bottom-nav [class*="Drawer-overlay"],
        body.has-mobile-bottom-nav [class*="Drawer-backdrop"] {
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          height: 100% !important;
          background-color: rgba(0, 0, 0, 0.45) !important;
          opacity: 1 !important;
        }
        body.has-mobile-bottom-nav [class*="Modal-opened"],
        body.has-mobile-bottom-nav [class*="Modal-overlay"],
        body.has-mobile-bottom-nav [class*="Modal-backdrop"] {
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: var(--mobile-bottom-nav-offset, 4.5rem) !important;
          height: auto !important;
          background-color: rgba(0, 0, 0, 0.45) !important;
          opacity: 1 !important;
        }
        body.has-mobile-bottom-nav.mobile-account-sheet-open .mobile-bottom-nav__shell,
        body.has-mobile-bottom-nav.mobile-account-sheet-open .mobile-bottom-nav {
          display: block !important;
          visibility: visible !important;
          opacity: 1 !important;
          z-index: 10000000010 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function watchAccountDrawer() {
    let syncTimer;
    const scheduleSync = () => {
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(() => {
        log('watchAccountDrawer: scheduled sync');
        syncAccountSheetState();
      }, 120);
    };

    scheduleSync();
    new MutationObserver((mutations) => {
      const relevant = mutations.some((m) => {
        if (m.type !== 'childList') return false;
        const nodes = [...m.addedNodes, ...m.removedNodes];
        return nodes.some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches?.('[class*="Drawer-"], shopify-account') ||
              node.querySelector?.('[class*="Drawer-"], shopify-account')),
        );
      });
      if (relevant) scheduleSync();
    }).observe(document.body, { childList: true, subtree: true });
  }

  function watchShopifyAccountSheet() {
    const accountEl = document.querySelector('shopify-account');
    if (!accountEl?.shadowRoot) {
      window.setTimeout(watchShopifyAccountSheet, 500);
      return;
    }

    let shadowTimer;
    const scheduleShadowSync = () => {
      window.clearTimeout(shadowTimer);
      shadowTimer = window.setTimeout(syncAccountSheetState, 120);
    };

    scheduleShadowSync();
    new MutationObserver(scheduleShadowSync).observe(accountEl.shadowRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open'],
    });
  }

  watchShopifyAccountSheet();
  watchAccountDrawer();

  const BOOST_FILTER_MOBILE_ID = 'boost-sd_filter-tree-mobile';
  const BOOST_FILTER_OPEN_CLASS = 'boost-sd-filter-drawer-open';

  function isBoostFilterDrawerOpen() {
    // Show Results CTA is the most reliable open signal for Boost SD
    if (isElementPaintedInViewport(document.querySelector('.boost-sd__button--result'))) {
      return true;
    }

    const modal =
      document.getElementById(BOOST_FILTER_MOBILE_ID) ||
      document.querySelector('#boost-sd_filter-tree-mobile, [id*="filter-tree-mobile"]');
    return isElementPaintedInViewport(modal);
  }

  function syncBoostFilterDrawerState() {
    document.body.classList.toggle(BOOST_FILTER_OPEN_CLASS, isBoostFilterDrawerOpen());
  }

  function watchBoostFilterDrawer() {
    let syncTimer;
    const scheduleSync = () => {
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(syncBoostFilterDrawerState, 50);
    };

    scheduleSync();
    new MutationObserver(scheduleSync).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden', 'hidden'],
    });
    document.addEventListener('click', scheduleSync, true);
    document.addEventListener('transitionend', scheduleSync, true);
  }

  watchBoostFilterDrawer();

  let searchLayoutTimer;
  new MutationObserver(() => {
    if (!isSearchOpen()) return;
    window.clearTimeout(searchLayoutTimer);
    searchLayoutTimer = window.setTimeout(applySearchBottomOffset, 30);
  }).observe(document.body, { childList: true, subtree: true });

  function getDesktopAccountLink() {
    return document.querySelector(
      "[data-target='desktop'] [data-name='account'] .section-header__list-item-link, .desktop_header_icon [data-name='account'] .section-header__list-item-link",
    );
  }

  function openAccountModal() {
    const desktopAccount = getDesktopAccountLink();
    log('openAccountModal', { found: Boolean(desktopAccount), href: desktopAccount?.href });

    if (!desktopAccount) {
      log('openAccountModal: desktop account link not found');
      return false;
    }

    const desktopSection = desktopAccount.closest('[data-target="desktop"]');
    const hadHiddenDesktop = desktopSection && getComputedStyle(desktopSection).display === 'none';
    if (hadHiddenDesktop) {
      desktopSection.style.setProperty('display', 'block', 'important');
      desktopSection.style.setProperty('visibility', 'hidden', 'important');
      desktopSection.style.setProperty('position', 'absolute', 'important');
      desktopSection.style.setProperty('pointer-events', 'none', 'important');
      desktopSection.style.setProperty('width', '0', 'important');
      desktopSection.style.setProperty('height', '0', 'important');
      desktopSection.style.setProperty('overflow', 'hidden', 'important');
    }

    desktopAccount.click();
    log('openAccountModal: clicked desktop account link');

    if (hadHiddenDesktop) {
      window.requestAnimationFrame(() => {
        desktopSection.style.removeProperty('display');
        desktopSection.style.removeProperty('visibility');
        desktopSection.style.removeProperty('position');
        desktopSection.style.removeProperty('pointer-events');
        desktopSection.style.removeProperty('width');
        desktopSection.style.removeProperty('height');
        desktopSection.style.removeProperty('overflow');
      });
    }

    return true;
  }

  function triggerDesktopAccount() {
    log('triggerDesktopAccount: start');
    window.clearTimeout(accountCloseTimer);
    accountCloseTimer = null;
    accountSheetOpen = true;
    document.body.classList.add('mobile-account-sheet-open');
    syncHeaderAnnouncementForOverlays();
    pressNavAction('account');
    setActiveItem();

    const opened = openAccountModal();
    log('triggerDesktopAccount: openAccountModal result', opened);

    window.setTimeout(() => {
      syncAccountSheetState();
      setActiveItem();
    }, 100);
    window.setTimeout(() => {
      syncAccountSheetState();
      setActiveItem();
    }, 400);
  }

  function openCategoryMenu() {
    const toggler = getMobileNavToggler();
    if (!toggler || document.body.classList.contains('mobile-menu-sheet-open')) return;

    if (toggler.classList.contains('menu-is-active')) {
      toggler.classList.remove('menu-is-active');
      toggler.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-is-active');
      document.querySelector('.header')?.classList.remove('menu-is-active');
    }

    toggler.click();
  }

  function forceCloseCategorySheetState() {
    document.body.classList.remove(
      'mobile-menu-sheet-open',
      'mobile-menu-sheet-dismissing',
      'menu-is-active',
    );
    document.querySelector('.header')?.classList.remove('menu-is-active');
    const toggler = getMobileNavToggler();
    if (toggler) {
      toggler.classList.remove('menu-is-active');
      toggler.setAttribute('aria-expanded', 'false');
    }
    const panel = document.querySelector('.menu_toggle .mobile_menu.section-header__list-box');
    if (panel) panel.setAttribute('aria-hidden', 'true');
    document.body.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow');
    document
      .querySelectorAll(
        '.section-header__list.dropdown--active, .section-header__list-item.dropdown--active',
      )
      .forEach((el) => el.classList.remove('dropdown--active'));
    document.querySelectorAll('.section-header__list-item-dropdown-toggler').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  function closeCategoryMenuWithoutToggle() {
    forceCloseCategorySheetState();
  }

  function closeCategoryMenu() {
    if (!document.body.classList.contains('mobile-menu-sheet-open')) return;

    const toggler = getMobileNavToggler();
    if (!toggler) return;

    if (!toggler.classList.contains('menu-is-active')) {
      closeCategoryMenuWithoutToggle();
      syncSheetBackdrop();
      setActiveItem();
      return;
    }

    toggler.click();
  }

  function closeCategoryMenuAnimated(onComplete) {
    if (categoryCloseInProgress) return;
    const sheet = getCategorySheet();
    const categoryOpen = document.body.classList.contains('mobile-menu-sheet-open');

    if (!categoryOpen || !sheet) {
      onComplete?.();
      return;
    }

    categoryCloseInProgress = true;
    const backdrop = document.getElementById('mobile-sheet-backdrop');
    let finished = false;

    const finish = () => {
      if (finished) return;
      finished = true;
      categoryCloseInProgress = false;
      sheet.classList.remove('mobile-menu-sheet--closing');
      sheet.style.willChange = '';
      sheet.style.transform = '';
      backdrop?.classList.remove('mobile-sheet-backdrop--closing');
      forceCloseCategorySheetState();
      releaseOverlayNavLock('category');
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          syncSheetBackdrop();
          onComplete?.();
        });
      });
    };

    document.body.classList.add('mobile-menu-sheet-dismissing');
    window.requestAnimationFrame(() => {
      sheet.style.willChange = 'transform';
      sheet.classList.add('mobile-menu-sheet--closing');
      backdrop?.classList.add('mobile-sheet-backdrop--closing');
      const onSheetAnimationEnd = (ev) => {
        if (ev.target !== sheet || ev.animationName !== 'mobile-menu-sheet-out') return;
        sheet.removeEventListener('animationend', onSheetAnimationEnd);
        finish();
      };
      sheet.addEventListener('animationend', onSheetAnimationEnd);
      window.setTimeout(() => finish(), SHEET_CLOSE_MS + 60);
    });
  }

  function setNavActionActive(activeAction, { animateIndicator = true } = {}) {
    const actions = bottomNav.querySelectorAll('[data-mobile-nav-action]');
    actions.forEach((el) => el.classList.remove('mobile-bottom-nav__action--active'));

    if (!activeAction) {
      updateNavIndicator(null);
      return;
    }

    const activeEl = bottomNav.querySelector(`[data-mobile-nav-action="${activeAction}"]`);
    activeEl?.classList.add('mobile-bottom-nav__action--active');

    if (activeAction === 'category') {
      activeEl?.setAttribute('aria-expanded', 'true');
    } else {
      bottomNav.querySelector('[data-mobile-nav-action="category"]')?.setAttribute('aria-expanded', 'false');
    }

    updateNavIndicator(activeAction, { animate: animateIndicator });
  }

  function transitionToNavAction(targetAction, href) {
    if (searchPanelOpen) closeMobileSearch();
    if (accountSheetOpen) {
      accountSheetOpen = false;
      wasAccountDrawerOpen = false;
      document.body.classList.remove('mobile-account-sheet-open');
      syncHeaderAnnouncementForOverlays();
    }

    const categoryOpen = document.body.classList.contains('mobile-menu-sheet-open');
    pressNavAction(targetAction);

    const releaseLock = () => {
      if (href) {
        markPendingNavAction(targetAction);
        window.location.assign(href);
        return;
      }
      navTransitionLock = null;
      syncHeaderAnnouncementForOverlays();
      setActiveItem();
    };

    if (categoryOpen) {
      closeCategoryMenuAnimated(releaseLock);
      return;
    }

    window.setTimeout(releaseLock, INDICATOR_TRANSITION_MS);
  }

  const bodyObserver = new MutationObserver(() => {
    syncSearchPanelState();
    syncCategorySheetState();
    if (!navTransitionLock && !indicatorAnimating) setActiveItem();
    syncSheetBackdrop();
    if (isSearchOpen()) {
      applySearchBottomOffset();
    }
  });
  bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  bodyObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  document.addEventListener(
    'click',
    (ev) => {
      const searchCloseTrigger = ev.target.closest(
        '.boost-pfs-search-suggestion-mobile-top-panel .boost-pfs-search-btn-close-suggestion, .boost-pfs-search-suggestion-style3-top-panel .boost-pfs-search-btn-close-suggestion, .boost-pfs-search-suggestion-mobile-overlay, .boost-sd__search-bar-wrapper .boost-sd__button-text-x--close-style1, .boost-sd__search-bar-wrapper .boost-sd__button-text-x--close-style3',
      );
      if (!searchCloseTrigger) return;

      searchPanelOpen = false;
      document.body.classList.add('mobile-nav-search-dismissed');
      window.setTimeout(() => releaseOverlayNavLock('search'), 0);
    },
    true,
  );

  document.addEventListener(
    'click',
    (ev) => {
      if (!document.body.classList.contains('mobile-menu-sheet-open')) return;
      const sheet = document.querySelector('.mobile_menu--bottom-nav');
      if (!sheet) return;
      if (sheet.contains(ev.target)) return;
      if (ev.target.closest('[data-mobile-nav-action="category"]')) return;
      if (ev.target.closest('.mobile-bottom-nav, .mobile-bottom-nav__shell')) return;
      closeCategoryMenuAnimated(() => setActiveItem());
    },
    true,
  );

  document.addEventListener('keydown', (ev) => {
    if (ev.key !== 'Escape') return;
    if (accountSheetOpen) {
      accountSheetOpen = false;
      wasAccountDrawerOpen = false;
      document.body.classList.remove('mobile-account-sheet-open');
      syncHeaderAnnouncementForOverlays();
      releaseOverlayNavLock('account');
      setActiveItem();
    }
  });

  const cartBadge = bottomNav.querySelector('.mobile-bottom-nav__badge');
  if (cartBadge) {
    const syncCartBadge = () => {
      const count = parseInt(cartBadge.textContent.trim(), 10) || 0;
      cartBadge.dataset.cartCount = String(count);
      cartBadge.toggleAttribute('hidden', count <= 0);
    };
    syncCartBadge();
    new MutationObserver(syncCartBadge).observe(cartBadge, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  bottomNav.addEventListener('click', (ev) => {
    const actionEl = ev.target.closest('[data-mobile-nav-action]');
    if (!actionEl || !isMobileBottomNavViewport()) return;

    const action = actionEl.dataset.mobileNavAction;

    if (action === 'category') {
      ev.preventDefault();
      const wasSearchOpen = searchPanelOpen || isSearchOpen();
      if (wasSearchOpen) closeMobileSearch();
      if (document.body.classList.contains('mobile-menu-sheet-open')) {
        navTransitionLock = null;
        closeCategoryMenuAnimated(() => setActiveItem());
      } else {
        pressNavAction('category');
        window.setTimeout(openCategoryMenu, wasSearchOpen ? 150 : 0);
      }
      return;
    }

    if (action === 'search') {
      ev.preventDefault();
      const categoryOpen = document.body.classList.contains('mobile-menu-sheet-open');
      pressNavAction('search');
      searchPanelOpen = true;
      if (categoryOpen) {
        closeCategoryMenuAnimated(() => openMobileSearch());
        return;
      }
      openMobileSearch();
      return;
    }

    if (action === 'account') {
      ev.preventDefault();
      log('account click');
      window.clearTimeout(accountCloseTimer);
      accountCloseTimer = null;
      if (searchPanelOpen || isSearchOpen()) closeMobileSearch();
      searchPanelOpen = false;
      pressNavAction('account');
      accountSheetOpen = true;
      document.body.classList.add('mobile-account-sheet-open');
      syncHeaderAnnouncementForOverlays();
      setActiveItem();
      if (
        document.body.classList.contains('mobile-menu-sheet-open') ||
        categoryCloseInProgress
      ) {
        log('account click: closing category first');
        closeCategoryMenuAnimated(() => triggerDesktopAccount());
        return;
      }
      triggerDesktopAccount();
      return;
    }

    if (action === 'home' || action === 'cart') {
      const href = actionEl.getAttribute('href');
      const isCurrentPage =
        (action === 'home' && bottomNav.dataset.pageType === 'index') ||
        (action === 'cart' && bottomNav.dataset.pageType === 'cart');
      const overlayOpen = hasOpenNavOverlay();

      if (overlayOpen) {
        ev.preventDefault();
        transitionToNavAction(action, isCurrentPage ? null : href);
        return;
      }

      if (!isCurrentPage && href) {
        ev.preventDefault();
        transitionToNavAction(action, href);
        return;
      }

      if (isCurrentPage) {
        ev.preventDefault();
        if (searchPanelOpen) {
          pressNavAction(action);
          closeMobileSearch();
          return;
        }
        syncHeaderAnnouncementForOverlays();
      }

      pressNavAction(action);
    }
  });
})();
